// extracted by mini-css-extract-plugin
module.exports = {"container":"AddOfflineMessageSkeleton_container__WYECJ","placeholder":"AddOfflineMessageSkeleton_placeholder__P_Ca_","button":"AddOfflineMessageSkeleton_button__KUkP0"};